import {useCallback, useEffect, useState} from 'react';
import {makeStyles, Grid} from "@material-ui/core";
import UtilService from "../../../../../../helper/service";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {addOverviewToAnalysisKeyMoment} from '../../../../../../store/actions/creator/analysis'
import roles from "../../../../../../helper/roles";
import AnalyzeKeyMomentPopOut from '../../../../../atoms/creator/analyzeKeyMomentPopout';
import VideoImage from './videoImage';

const useStyles = makeStyles(() => ({
  image: {
    //width: 250,
    height: 167,
    borderRadius: 15,
    cursor: 'pointer',
    position: 'relative',
    overflow: "hidden",

    '@media (min-width: 1010px) and (max-width: 1100px)': {
      width: 200,
    },
    '@media (min-width: 1100px) and (max-width: 1300px)': {
      width: 220,
    },
    '& img': {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: "0",
      left: "0"
    }
  },
  item: {
    flex: 1,
    minWidth: '33.33%',
    maxWidth: '34%',
    padding: '25px 30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '@media (max-width: 400px)': {
      padding: '15px 0',
      minWidth: '100%',
      maxWidth: '100%',
    },
    '@media screen and (max-width: 1009px)': {
      minWidth: '100%',
      maxWidth: '100%',
    }
  },

  popover: {
    background: '#fff',
    width: 230,
    boxShadow: '0px 0px 10px #00000033',
    borderRadius: 10,
    marginTop: "-140px",
    position: 'absolute',
    marginLeft: 10,
    zIndex: 2
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 0 -2px 12px'
  },
  modalTitle: {
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 14
  },
  modalCloseIcon: {
    width: 10,
    height: 10,
    background: 'transparent'
  },
  pane: {
    display: 'flex',
    flexDirection: 'row',
    color: '#8191A1',
    marginTop: 6
  },
  smallRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#8191A1',
  },
  timeLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 10,
    marginRight: 3
  },
  segmentWord: {
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  btn: {
    marginTop: 18,
    marginLeft: 5,
    padding: '3px 4px 3px 4px',
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 10,
    background: '#F0F0F0',
    borderRadius: 6,
    textTransform: 'none',
    '&:hover': {
      background: '#e7e5e5',
    },
    '& img': {
      marginRight: 3
    }
  },
  icon: {
    width: 24,
    height: 24
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 10,
  },
  title: {
    marginTop: 5,
    fontSize: 12,
    fontFamily: 'Spartan-bold',
    letterSpacing: '2px',
    textTransform: 'uppercase'
  },
  numberTitle: {
    marginTop: 5,
    fontSize: 16,
    fontFamily: 'Spartan-extrabold',
    padding: '0 10px'
  },
  presentation: {
    fontSize: 16,
    fontFamily: 'Spartan-extrabold',
    color: '#8191A1',
    paddingLeft: 10,
    marginTop: 5
  },
  label: {
    fontSize: 12,
    fontFamily: 'roboto-bold',
    color: '#697683',
    textAlign: 'left',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#1DB859',
    fontSize: 12,
    margin: 0
  },
  dotIcon: {
    position: 'absolute',
    width: 18,
    height: 18,
    borderRadius: 10,
    backgroundColor: '#FFFFFF',
    opacity: 0.5,
    marginLeft: 30,
    marginTop: 40
  },
  keyMoment: {
    position: 'absolute',
    fontSize: 15,
    fontFamily: 'roboto-bold',
    color: '#FFFFFF',
    opacity: 0.5,
    letterSpacing: 3,
    paddingLeft: 20,
    paddingTop: 80,
    textTransform: 'uppercase'
  },
  imgTime: {
    position: 'absolute',
    fontSize: 40,
    fontFamily: 'Spartan-bold',
    color: '#FFFFFF',
    paddingLeft: 20,
    paddingTop: 105
  },
  modalBadgeIcon: {
    width: 25,
    height: 25
  },
  popperBadgeIcon: {
    width: 20,
    height: 20
  },
  clock: {
    width: 12,
    height: 12,
    marginRight: 3
  },
  pencil: {
    width: 12,
    height: 12,
    marginRight: 5
  },
  name_index: {
    margin: '0 7px',
    fontSize: 18
  },
  label_index: {
    fontFamily: 'Spartan-bold',
    letterSpacing: 1.2,
    paddingTop: 4,
    textTransform: 'uppercase'
  },
  loading: {
    width: 60,
    height: 25
  },
  clipName: {
    margin: '40px 40px 40px 0'
  },
  btnOK: {
    height: 37,
    padding: '18px',
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
}));
interface IProps {
  type: string,
  moment: any,
  session: any;
  isMobile: boolean;
}

const HighLightGridItem = (props: IProps) => {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { type, moment, session } = props;
  const { session_type } = session;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { stimulusList } = useSelector((state: any) => state.creatorExperienceManager);
  const { analyseStart, cliped, stimulus } = useSelector((state: any) => state.analysis);
  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const [bgThumb, setBgThumb] = useState("");
  const immersionIndex = (moment.immersion_index && Object.keys(moment.immersion_index).length !== 0) ? moment.immersion_index : null;
  const [overlay, setOverlay] = useState(null);

  useEffect(() => {
    if (stimulusList && stimulusList.length > 0) {
      if (stimulusList[0].thumbnails && stimulusList[0].thumbnails.length > 0)
        setBgThumb(stimulusList[0].thumbnails[0].url)
    }
  }, [stimulusList]);

  const getColor = (type: string) => {
    switch (type) {
      case 'best':
        return '#1CB858';
      case 'worst':
        return '#ED564A';
      default:
        return '#1CB858';
    }
  };

  const getEpochTime = useCallback((epoch_time: number) => {
    if (session_type === 'ASYNC') {
      return UtilService.convertHighlightsTime(epoch_time)
    } else {
      return UtilService.convertHighlightsTime(epoch_time - Number(analyseStart));
    }
  }, [session_type, analyseStart]);

  const goAnalyzeTab = (keyMoment: any) => {
    dispatch(addOverviewToAnalysisKeyMoment(keyMoment));
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
      }
    }
    history.push({
      pathname: url,
    })
  };

  const stylebg = {
    backgroundColor: stimulus ? '#000' : getColor(type)
  };

  const start = cliped ? cliped.start_clip - analyseStart : 0;
  const graphStart = cliped ? cliped.start_clip : analyseStart;
  const segment_start = (moment?.epoch_start) - (session_type === 'ASYNC' ? 0 : graphStart);
  const segment_end = (moment?.end ? moment.end : moment?.epoch_end) - (session_type === 'ASYNC' ? 0 : graphStart);
  const customData: any = {
    overall_index: immersionIndex['overall_index'],
    context_indicator: immersionIndex['context_indicator'],
    safety_index: moment.safety_index.overall_index > 1 ? moment.safety_index.overall_index : '--',
    safety_indicator: moment.safety_index.overall_index > 1 && moment.safety_index.context_indicator,
    safety_color: moment.safety_index.color_indicator,
    color: moment.immersion_index.color_indicator,
    type: 'Key Moment',
    title: '',
    segment_start: UtilService.getTimeLabel(segment_start, 1, session_type === 'ASYNC' ? 0 : start),
    segment_length: UtilService.getTimeLabel(segment_end - segment_start, 1, 0),
    segment_end: UtilService.getTimeLabel(segment_end, 1, session_type === 'ASYNC' ? 0 : start),
    start: moment.epoch_start,
    end: moment.epoch_end,
    length: moment.epoch_end - moment.epoch_start,
    epoch_start: moment.epoch_start,
  };

  const handleModal = async (e: any) => {
    setAnchorEl(e.currentTarget);
    setOverlay(customData);
  };

  if (bgThumb) {

  }
  return (
    <Grid item xs={4}>
      

        
        <div
          aria-describedby={'simple-popover'}
          className={classes.image}
          onClick={(e) => handleModal(e)}
          style={stylebg}
        >

          {stimulus && <VideoImage
            video={stimulus?.play_url ? stimulus?.play_url : stimulus?.stimulus_link}
            stimulus_video_length={stimulus?.stimulus_video_length}
            videoStart={moment?.epoch_start}
            videoEnd={moment?.epoch_end}
            small={true}
          />}

{/*
          {bgThumb === "" && <div id={'dot_icon_2'} className={classes.dotIcon} />}
          <span className={classes.keyMoment}>KEY MOMENT</span>
          <span className={classes.imgTime}>{getEpochTime(moment['epoch_start'])}</span>
          */}
        </div>

        <div>
          <div className={classes.titleSection}>
            <img className={classes.icon} src={`/assets/icons/overview/${type}-moment.svg`} alt='Moment' />
            <div className={classes.numberTitle} style={{ color: getColor(type) }}>
              {immersionIndex['overall_index'] > 1 ? immersionIndex['overall_index'] : "--"}
            </div>
            <div className={classes.title} style={{ color: getColor(type) }}>
              {immersionIndex['overall_index'] > 1 ? immersionIndex['context_indicator'] : '--'}
            </div>
          </div>
          <div className={classes.titleSection}>
            <img className={classes.icon} src={`/assets/icons/overview/watch.svg`} alt='Moment' />
            <div className={classes.presentation}>{getEpochTime(moment['epoch_start'])} to {getEpochTime(moment['epoch_end'])}</div>
          </div>
        </div>


     

      {overlay && <AnalyzeKeyMomentPopOut
        anchorEl={anchorEl}
        overlay={overlay}
        setAnchorEl={setAnchorEl}
        goAnalyzeTab={goAnalyzeTab}
        overview={true}
      />}

    </Grid> 
  );
};

export default HighLightGridItem;